import SettingHeader from '../Header';
import SlackConnectionList from './SlackConnection/SlackConnectionList';

const SlackChatBotConnection = () => {
  return (
    <>
      <SettingHeader title="Slack Chatbot" />
      <div className="flex flex-1 flex-col overflow-auto">
        <div className="p-8">
          <div className="flex flex-col gap-2">
            <SlackConnectionList />
          </div>
        </div>
      </div>
    </>
  );
};

export default SlackChatBotConnection;
